import React from 'react';
import {RestoreScreen} from './Edit';

// 具体的な実装は編集画面側で。

export const Copy: React.FC = React.memo(() => {
  return <RestoreScreen editMode="copy" />;
});
